import React from 'react'
import styled from 'styled-components'

export interface IChipProps extends React.InputHTMLAttributes<any> {
  label: string
  color?: string
  disabled?: boolean
  deleteFunction: (item: string) => void
}

const StyledChip = styled.div<{
  hasError?: boolean
  isFocus?: boolean
  themeColor?: string
}>`
  padding: 2px 6px;
  display: flex;
  position: relative;
  box-sizing: border-box;
  border-radius: 20px;
  width: fit-content;
  background-color: ${(props) => props.theme[props.themeColor || 'primaryColor']};
  color: white;
  align-items: center;
  margin: 2px 4px;
  font-size: 0.9em;

  max-width: 100%;

  & > span {
    word-wrap: break-word;
    max-width: calc(100% - 20px);
  }
`

const RemoveButton = styled.div`
  margin-left: 5px;
  color: black;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 15px;
  color: ${(props) => props.theme['primaryColor']};
  background-color: rgba(255, 255, 255, 0.3);
  font-family: 'roboto';
  font-weight: bolder;
  font-size: 0.9em;

  &:hover {
    background-color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
  }
`

export class Chip extends React.Component<IChipProps> {
  render() {
    return (
      <>
        <StyledChip {...this.props}>
          <span>{this.props.label}</span>
          {!this.props.disabled && (
            <RemoveButton onClick={() => this.props.deleteFunction(this.props.label)}> X </RemoveButton>
          )}
        </StyledChip>
      </>
    )
  }
}
